import { convertToLocalStyle, helpbuttonStyle, uiblockerStyle } from '@bingads-webui-campaign-react/common-styles';
import { pagePaddingStyle } from '@bingads-webui-campaign-react/page-padding-style';

const noDataStyle = palette => ({
  color: palette.neutralSecondary,
  fontSize: 26,
  paddingLeft: 32,
});

const switchButtonStyle = palette => ({
  background: palette.white,
  color: palette.themePrimary,
  minWidth: 32,
  minHeight: 32,
  margin: 0,
  padding: '0 12px 0 8px',

  '&.active': {
    background: palette.themePrimary,
    color: palette.white,
    border: 0,
  },
});

const assetGroupStatusStyle = palette => ({
  backgroundColor: 'transparent',
  height: 20,
  padding: 0,

  '&:hover': {
    backgroundColor: 'transparent',

    '& .ms-Button-menuIcon': {
      visibility: 'visible',
    },
  },

  '& .ms-Button-flexContainer': {
    justifyContent: 'start',
  },

  '& .ms-Button-menuIcon': {
    visibility: 'hidden',
  },

  '& .ms-Button-icon': {
    margin: 0,
  },

  '&.status-active .ms-Button-icon': {
    color: '#107c10',
    fontSize: 12,
  },

  '&.status-paused .ms-Button-icon': {
    color: palette.neutralPrimary,
    fontSize: 12,
  },

  '&.status-expired .ms-Button-icon': {
    color: palette.neutralPrimary,
    fontSize: 14,
  },
});

export const getStyle = (_, { palette = {} }) => ({
  '@global': {
    ...pagePaddingStyle(),
    ...uiblockerStyle({ palette }),

    '.appads-asset-group-status-menu': {
      '& .selected .ms-ContextualMenu-itemText': {
        fontWeight: 'bold',
      },

      '& .status-enabled .ms-ContextualMenu-icon': {
        color: '#107c10',
        fontSize: 12,
      },

      '& .status-paused .ms-ContextualMenu-icon': {
        color: palette.neutralPrimary,
        fontSize: 12,
      },
    },
  },

  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',

    '& .ba-content-footer': {
      marginTop: 'auto',
    },
  },

  gridContainer: {
    '& .ms-DetailsList': {
      fontSize: 14,
    },

    '& .ms-DetailsHeader .ms-DetailsHeader-cellName': {
      width: '100%',
    },

    '& .ms-DetailsRow-cell': {
      alignItems: 'center',
    },

    '& .header-status .ms-Icon': {
      color: '#8a8886',
      fontSize: 12,
    },

    '& .appads-asset-group-status': assetGroupStatusStyle(palette),

    '& .appads-column-aggregated-row': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: 14,
    },

    '& .appads-column-asset-group, .appads-column-end-date': {
      display: 'flex',
      flexDirection: 'row',

      '& > div': {
        flexGrow: 1,
      },

      '& > button': {
        height: 20,
        visibility: 'hidden',
      },

      '&:hover > button': {
        visibility: 'visible',
      },
    },

    '& .campaign-details-list-pagination': {
      padding: '0 15px',
    },

    '& .grid-no-data': noDataStyle(palette),

    '& .view-switch-button': switchButtonStyle(palette),

    '& .grid-header-helpId': convertToLocalStyle(helpbuttonStyle(palette)),

    '& .inline-edit-popup': {
      background: palette.white,
      padding: '24px 16px',

      '& .ms-Callout-main': {
        overflow: 'visible',
      },

      '& .campaigns-date-picker': {
        width: '8em',

        '& .radioInput label': {
          display: 'inline-block',
          marginLeft: 8,
          position: 'relative',
          top: -5,
        },
      },

      '& .actions': {
        margin: '16px 0 8px 0',

        '& button ~ button': {
          marginLeft: 8,
        },
      },

      '& .error': {
        color: '#A80000',
      },
    },

    '& .assets-status-missing-video-warning': {
      paddingLeft: 0,
      justifyContent: 'left',
      marginRight: 0,
    },
  },
});
